import React, { useContext } from 'react';
import { Message } from 'primereact/message';
import AuthContext from '../../components/AuthContext';
import { LocaleContext } from '../../components/LocaleContext';
import { hasCrmModuleCompleteList } from '../../utils/crmCommunicationPermissions';
import CrmCommunicationTicketsList from './CrmCommunicationTicketsList';
import { CRM_COMM_PAGE_ALL_BUSINESS_BY_STATE } from '../../utils/crmCommunicationTableColumns';

export const CRM_ALL_BUSINESS_MASK_BY_STATE = 'cust030';

/** Všetky obchody → Podľa stavu (cust030): rovnaké UI ako cust027, širší scope dát. */
export default function CustomerAllBusinessByStateList(props) {
  const { user } = useContext(AuthContext);
  const { t } = useContext(LocaleContext);
  const canAccess = hasCrmModuleCompleteList(user) || !!user?.is_superuser;

  if (!canAccess) {
    return (
      <div className="p-4">
        <Message severity="warn" text={t('CustomerAllPartnersList.AccessDenied')} />
      </div>
    );
  }

  return (
    <CrmCommunicationTicketsList
      {...props}
      crmTicketsLayout
      stateListLayout
      types="quote_request"
      mineOnlyDefault={false}
      listPageKey={CRM_COMM_PAGE_ALL_BUSINESS_BY_STATE}
      maskCode={CRM_ALL_BUSINESS_MASK_BY_STATE}
    />
  );
}
